import { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMatch } from 'react-router-dom';
import { isChristmasTime } from '@/utils/isChristmasTime';
import { fetchDeliveryEtaAction } from '@/redux/core/actions/fetchDeliveryEtaAction';
import { getDeliveryEta } from '@/redux/core/getters/getDeliveryEta';
import { useReduxDraftDispatch } from '@/redux/draft/draftDispatch';
import { getProductTypeId } from '@/redux/draft/getters/getProductTypeId';
import { getPrintTypeIdsForDeliveryETA } from '@/redux/printTypes/getters/getPrintTypeIdsForDeliveryETA';
import { StoreDispatch } from '@/redux/types';
import { setWarningAction } from '@/components/draft/draftState/actions/setWarningAction';

export const DeliveryChristmasHint: FunctionComponent = () => {
  const productTypeId = useSelector(getProductTypeId);
  const printTypeIds = useSelector(getPrintTypeIdsForDeliveryETA);
  const dispatch = useDispatch<StoreDispatch>();
  const draftDispatch = useReduxDraftDispatch();

  const deliveryEta = useSelector(getDeliveryEta(productTypeId, printTypeIds));
  const isZeroStateActive = Boolean(useMatch('/get-started'));

  useEffect(() => {
    if (deliveryEta === undefined) {
      dispatch(fetchDeliveryEtaAction(productTypeId, printTypeIds));
    }
  }, [dispatch, deliveryEta, productTypeId, printTypeIds]);

  useEffect(() => {
    if (deliveryEta && !isZeroStateActive) {
      const to = new Date(deliveryEta.latestDateUTC);
      if (isChristmasTime() && !isChristmasTime(to)) {
        draftDispatch(setWarningAction('DeliveryHint', 'christmasDeliveryTime.hint'));
      }
    }
  }, [deliveryEta, draftDispatch, isZeroStateActive]);

  return null;
};
